import { Button, Drawer } from 'antd';
import React from 'react';
import { Link } from 'react-scroll';
import { useLanguage } from '../context/LanguageContext';
import { CloseOutlined } from '@ant-design/icons';
const Menu = (props) => {
    const { menuCategogries, setMenuTrayOpen, menuTrayOpen } = props;
    const { t } = useLanguage();
    // if (menuCategogries.length <= 2) return '';
    return (
        <>
            <Button
                type='primary'
                className=' fixed bottom-16  z-50  flex justify-center items-center w-auto left-2/4 -translate-x-2/4 bg-theme'
                onClick={() => setMenuTrayOpen((prevState) => !prevState)}
            >
                {t['ird_menu']}
            </Button>
            <Drawer
                title='Explore Categories'
                placement={'bottom'}
                closable={false}
                onClose={() => setMenuTrayOpen(false)}
                open={menuTrayOpen}
                className='category-modal'
                extra={
                    <Button
                        className='flex justify-center items-center'
                        onClick={() => setMenuTrayOpen(false)}
                    >
                        <CloseOutlined />
                    </Button>
                }
            >
                {menuCategogries.map((subcategory, index) => (
                    <Link
                        to={`${subcategory.id}`}
                        key={subcategory.id}
                        spy={true}
                        smooth={true}
                        offset={-160}
                        duration={500}
                        className={
                            'flex flex-row justify-between items-center bg-white p-3 rounded-lg mb-2 border ' +
                            (index === menuCategogries.length ? 'mb-6' : '')
                        }
                        onClick={() => {
                            setMenuTrayOpen(false);
                        }}
                    >
                        <div className=' text-black text-xs'>
                            {subcategory.name}
                        </div>
                    </Link>
                ))}
            </Drawer>
        </>
    );
};

export default Menu;
